const CODE_VERIFIER_KEY = "mercadolibre_code_verifier";
const OAUTH_STATE_KEY = "mercadolibre_oauth_state";

export const mercadolibreOAuthStorage = {
  save(codeVerifier: string, state: string) {
    sessionStorage.setItem(CODE_VERIFIER_KEY, codeVerifier);
    sessionStorage.setItem(OAUTH_STATE_KEY, state);
  },
  getCodeVerifier(): string | null {
    return sessionStorage.getItem(CODE_VERIFIER_KEY);
  },
  getState(): string | null {
    return sessionStorage.getItem(OAUTH_STATE_KEY);
  },
  clear() {
    sessionStorage.removeItem(CODE_VERIFIER_KEY);
    sessionStorage.removeItem(OAUTH_STATE_KEY);
  },
  isValidState(state: string | string[] | null | undefined): boolean {
    const savedState = this.getState();
    if (!savedState) return true;

    const receivedState = Array.isArray(state) ? state[0] : state;
    return receivedState === savedState;
  },
};
